/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteTraineesBySectorActions, {
    deleteTraineesBySectorTypes,
} from '../../../redux/collectData/deleteTraineesBySector'
import getTraineesBySectorActions from '../../../redux/collectData/getTraineesBySector'
import { Delete } from '../../../serveur/axios'

function* deleteTraineesBySectorSagas({ response }) {
    try {
        const responseDelete = yield Delete(
            `collect_data/graduate_training/${response.id}`
        )
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    deleteTraineesBySectorActions.deleteTraineesBySectorSuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    getTraineesBySectorActions.getTraineesBySectorRequest(
                        response.type
                    )
                ),
            ])
        } else {
            yield put(
                deleteTraineesBySectorActions.deleteTraineesBySectorFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(
            deleteTraineesBySectorActions.deleteTraineesBySectorFailure(error)
        )
    }
}

export function* deleteTraineesBySectorSaga() {
    yield takeLatest(
        deleteTraineesBySectorTypes.DELETE_TRAINEES_BY_SECTOR_REQUEST,
        deleteTraineesBySectorSagas
    )
}
